const getNameFromUrl = url => {
  let items = url.toLowerCase().split("/");
  if (items.length > 0) {
    return items[items.length - 1];
  }
  return "";
};

const getPartsName = fileName => {
  let result = { name: "", ext: "" };
  let p = fileName.split(".");
  if (p.length > 1) {
    result.ext = p.pop();
    result.name = p.join(".");
  }
  return result;
};

const getPartsNameFromUrl = url => {
  return getPartsName(getNameFromUrl(url));
};

const isImageExt = ext => {
  let lowerExt = ext.toLowerCase();
  return ["jpg", "jpeg", "png", "gif", "tiff"].some(ext => ext === lowerExt);
};

export { getNameFromUrl, getPartsName, getPartsNameFromUrl, isImageExt };
